// A pledge's commitment months as My BF Fulfilment shows them. From BF2026 a pledge
// runs five months, `month_1..5` = Oct..Feb; earlier years ran four, `month_1..4` =
// Nov..Feb. giving-api stores only the keys, so the mapping lives here.

const FIVE_MONTHS_FROM = 2026;
const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
const ONE_TIME_KEY = 'one_time_commitment';
const MONTH_KEYS = [1, 2, 3, 4, 5].map(n => `month_${n}_commitment`);

/** The year's months in order, as `{ key, label }` with labels like `Oct 2026`. */
export function commitmentMonths(year) {
  const campaignYear = Number(year);
  const fiveMonths = campaignYear >= FIVE_MONTHS_FROM;
  const firstMonth = fiveMonths ? 9 : 10; // October or November, 0-based
  const keys = fiveMonths ? MONTH_KEYS : MONTH_KEYS.slice(0, 4);
  return keys.map((key, index) => {
    const month = firstMonth + index;
    const label = `${MONTH_NAMES[month % 12]} ${campaignYear + Math.floor(month / 12)}`;
    return { key, label };
  });
}

/** Whether a commitment field holds an amount: 0 does, null and absent do not. */
export function hasAmount(value) {
  return value !== null && value !== undefined;
}

/** Whether any month holds an amount (0 included); false for a one-time pledge. */
export function hasMonthlyCommitment(commitment) {
  return MONTH_KEYS.some(key => hasAmount(commitment?.[key]));
}

/** The one-time amount plus every month. Amounts may arrive as strings. */
export function commitmentTotal(commitment) {
  return [ONE_TIME_KEY, ...MONTH_KEYS].reduce(
    (sum, key) => sum + (Number(commitment?.[key]) || 0),
    0,
  );
}
